import { render, staticRenderFns } from "./sTable.vue?vue&type=template&id=d5f036a2&scoped=true&"
import script from "./sTable.vue?vue&type=script&lang=js&"
export * from "./sTable.vue?vue&type=script&lang=js&"
import style0 from "./sTable.vue?vue&type=style&index=0&id=d5f036a2&scoped=true&lang=css&"
import style1 from "./sTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f036a2",
  null
  
)

export default component.exports